import { BadgeVariant, Flex, FlexProps, StatusBadge } from '@mprolab/uikit'
import { useTranslation } from 'react-i18next'
import React, { ReactNode } from 'react'

export enum TransactionViewType {
  FAILED = 'failed',
  PENDING = 'pending',
  SIGNING = 'SIGNING',
  SUCCESS = 'success',
  TRANSACTION_STATUS_ERROR = 'tx_status_error'
}
const getStatusBadgeTitle = (transactionView: TransactionViewType, customMsg?: string): string => {
  if (customMsg) return customMsg
  switch (transactionView) {
    case TransactionViewType.PENDING:
      return 'modal.transactionConfirmation'
    case TransactionViewType.SIGNING:
      return 'modal.continueInWallet'
    case TransactionViewType.SUCCESS:
      return 'modal.transactionSucessful'
    case TransactionViewType.FAILED:
      return 'modal.transactionFailed'
    case TransactionViewType.TRANSACTION_STATUS_ERROR:
      return 'modal.transactionProcessingDelay'
    default:
      return 'modal.somethingWentWrong'
  }
}
const getBadgeVariant = (transactionView: TransactionViewType): BadgeVariant => {
  switch (transactionView) {
    case TransactionViewType.PENDING:
    case TransactionViewType.SIGNING:
      return BadgeVariant.PENDING
    case TransactionViewType.SUCCESS:
      return BadgeVariant.SUCCESS
    case TransactionViewType.FAILED:
      return BadgeVariant.ERROR
    case TransactionViewType.TRANSACTION_STATUS_ERROR:
      return BadgeVariant.WARNING
    default:
      return null
  }
}
interface TransactionViewProps extends FlexProps {
  transactionView: TransactionViewType
  customMsg?: string
  firstChild?: ReactNode
  lastChild?: ReactNode
}
const TransactionView: React.FC<TransactionViewProps> = ({
  transactionView,
  firstChild,
  lastChild,
  customMsg,
  ...props
}) => {
  const { t } = useTranslation()
  const statusBadgeTitle = getStatusBadgeTitle(transactionView, customMsg)
  const statusBadgeVariant = getBadgeVariant(transactionView)
  return (
    <Flex flexDirection="column" gap="32px" alignItems="center" justifyContent="center" fullWidth {...props}>
      {React.isValidElement(firstChild) && firstChild}
      <StatusBadge title={t(statusBadgeTitle)} variant={statusBadgeVariant} />
      {React.isValidElement(lastChild) && lastChild}
    </Flex>
  )
}
export default TransactionView
